import { useCallback, useState } from 'react'
import sanitize from '../../sanitizers/course'
import Joi from 'joi'

const singleSchema = {
    id: Joi.string().allow(null).optional(),
    name: Joi.string().required().error(() => new Error('Name is required' )),
    date: Joi.date().required().error(() => new Error('Date is required' )),
    description: Joi.string().allow(null).optional(),
    facilitatorId: Joi.string().required().error(() => new Error('Facilitator is required' )),
    locationId: Joi.string().required().error(() => new Error('Location is required' )),
    hourId: Joi.string().required().error(() => new Error('Hour is required' )),
    durationId: Joi.string().required().error(() => new Error('Duration is required' )),
    minCapacity: Joi.number().required().error(() => new Error('Minimum capacity is required' )),
    maxCapacity: Joi.number().required().error(() => new Error('Maximum capacity is required' )),
    credits: Joi.number().required().error(() => new Error('Units is required' )),
    dimensions: Joi.array().allow(null).optional(),
    gradeLevels: Joi.array().required(),
    requirements: Joi.array().allow(null).optional(),
    occurrences: Joi.allow(null),
}

const occurrenceSchema = {
    date: Joi.date().required().error(() => new Error('Date is required' )),
    hourId: Joi.string().required().error(() => new Error('Hour is required' )),
    durationId: Joi.string().required().error(() => new Error('Duration is required' )),
}

const multipleSchema = {
    id: Joi.string().allow(null).optional(),
    name: Joi.string().required().error(() => new Error('Name is required' )),
    occurrences: Joi.array().items(Joi.object(occurrenceSchema)).min(1),
    date: Joi.date().allow(null).optional(),
    hourId: Joi.string().allow(null).optional(),
    durationId: Joi.string().allow(null).optional(),
    description: Joi.string().allow(null).optional(),
    facilitatorId: Joi.string().required().error(() => new Error('Facilitator is required' )),
    locationId: Joi.string().required().error(() => new Error('Location is required' )),
    minCapacity: Joi.number().required().error(() => new Error('Minimum capacity is required' )),
    maxCapacity: Joi.number().required().error(() => new Error('Maximum capacity is required' )),
    credits: Joi.number().required().error(() => new Error('Units is required' )),
    dimensions: Joi.array().allow(null).optional(),
    gradeLevels: Joi.array().required(),
    requirements: Joi.array().allow(null).optional()
}

const validator = (course, isNew) => {
    try {
        if (isNew) {
            Joi.assert(course, Joi.object(multipleSchema))
        } else {
            Joi.assert(course, Joi.object(singleSchema))
        }
        return
    } catch (err) {
        return err.message
    }
}

const useCourseValidation = ({
    onSuccess = (course) => {},
    onError = (error) => {},
    isNew
}) => {
    const [ error, setError ] = useState()

    const validateCourse = useCallback(course => {
        console.log('Validating:', course)
        const error = validator(sanitize(course), isNew)

        if (error) {
            console.log('Validation error:', error)
            setError(error)
            onError(error)
        } else {
            setError()
            onSuccess(course)
        }
    }, [onError, onSuccess, setError, sanitize, isNew])

    return {
        validateCourse,
        error
    }
}

export default useCourseValidation